(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-designer-founder"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const video = document.getElementById('founder-video');
    if (video) {
      const trigger = document.querySelector('.play-founder-video');
      trigger.addEventListener('click', function () {
        if(video.paused) {
            video.play();
            video.parentElement.classList.add('playing');
           // video.setAttribute('controls', 'controls');
        }else {
            video.pause();
            video.parentElement.classList.remove('playing');
            //video.removeAttribute('controls');
        }        
      });

      function resetVideo() {
        video.parentElement.classList.remove('playing');
        //video.removeAttribute('controls');
      }

      video.addEventListener('ended', resetVideo);
      video.addEventListener('pause', resetVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
